'use client';

const Button = ({
	type = 'primary',
	label,
	onClick,
	iconLeft,
	iconRight,
	disabled = false,
	loading = false,
	className = '',
	trackLabel,
	size = 'M',
	variant = 'filled', // filled, outlined, text
}) => {
	const baseStyles =
		'inline-flex items-center justify-center font-medium transition-all duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';

	const sizeStyles = {
		S: 'h-8 px-3 text-sm rounded-md',
		M: 'h-10 px-4 text-sm rounded-lg',
		L: 'h-12 px-6 text-base rounded-lg',
	};

	const getVariantStyles = () => {
		if (type === 'primary') {
			if (variant === 'outlined') {
				return 'bg-transparent border border-blue-600 text-blue-600 hover:bg-blue-50 focus:ring-blue-500';
			}
			if (variant === 'text') {
				return 'bg-transparent text-blue-600 hover:bg-blue-50 focus:ring-blue-500';
			}
			return 'bg-blue-600 text-white hover:bg-blue-700 focus:ring-blue-500 shadow-sm';
		}

		if (type === 'secondary') {
			if (variant === 'outlined') {
				return 'bg-transparent border border-gray-300 text-gray-700 hover:bg-gray-50 focus:ring-gray-500';
			}
			if (variant === 'text') {
				return 'bg-transparent text-gray-700 hover:bg-gray-50 focus:ring-gray-500';
			}
			return 'bg-white border border-gray-300 text-gray-700 hover:bg-gray-50 focus:ring-gray-500 shadow-sm';
		}

		if (type === 'danger') {
			if (variant === 'outlined') {
				return 'bg-transparent border border-red-600 text-red-600 hover:bg-red-50 focus:ring-red-500';
			}
			if (variant === 'text') {
				return 'bg-transparent text-red-600 hover:bg-red-50 focus:ring-red-500';
			}
			return 'bg-red-600 text-white hover:bg-red-700 focus:ring-red-500 shadow-sm';
		}

		// Default to secondary
		return 'bg-white border border-gray-300 text-gray-700 hover:bg-gray-50 focus:ring-gray-500 shadow-sm';
	};

	const finalButtonStyles = `${baseStyles} ${
		sizeStyles[size] || sizeStyles.M
	} ${getVariantStyles()}`;

	const handleClick = (event) => {
		if (disabled || loading) return;

		if (window.gtag) {
			window.gtag('event', 'button_click', {
				event_category: 'Button',
				event_label: trackLabel || label,
				value: 1,
			});
		}

		if (onClick) {
			onClick(event);
		}
	};

	return (
		<button
			onClick={handleClick}
			disabled={disabled || loading}
			className={`${finalButtonStyles} ${className}`}>
			{loading ? (
				<div className='w-4 h-4 border-2 border-t-transparent border-current rounded-full animate-spin'></div>
			) : (
				<>
					{iconLeft && (
						<span className='mr-2 flex-shrink-0'>{iconLeft}</span>
					)}
					{label}
					{iconRight && (
						<span className='ml-2 flex-shrink-0'>{iconRight}</span>
					)}
				</>
			)}
		</button>
	);
};

export default Button;
